import axios from 'axios'
const apiClientes = 'gestion-clientes/php/api/'

export default {
	buscar (filtro) {
		return axios.post(apiClientes + 'get-buscar.php', filtro)
	},
	getPermisos () {
		return axios.post(apiClientes + 'get-permisos.php')
	},
	getFormasPago () {
		return axios.post(apiClientes + 'get-formas-pago.php')
	},
	setCliente (datos) {
		return axios.post(apiClientes + 'set-cliente.php', datos)
	},
	getCliente (idCliente) {
		return axios.get(apiClientes + 'get-cliente.php?ID=' + idCliente)
	},
	liberar (idCliente) {
		return axios.post(apiClientes + 'apiLiberarCliente.php', {ClienteID: idCliente})
	},
	cerrado (idCliente, abierto) {
		return axios.post(apiClientes + 'apiCerrarCliente.php', {ClienteID: idCliente, abierto})
	},
	eliminar (idCliente) {
		return axios.get(apiClientes + 'del-cliente.php?ID=' + idCliente)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-clientes/vue/services/api.js